import { Link } from "react-router-dom";
import { site } from "@/config/site";

export const Monogram = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true" focusable="false">
    <rect x="1.5" y="1.5" width="61" height="61" rx="6" fill="#0F1E33" stroke="#C9A227" strokeWidth="1.5" />
    <path d="M14 46V18l10 15 10-15v28" fill="none" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M40 46V18h6.5a7.5 7.5 0 0 1 0 15H40" fill="none" stroke="#C9A227" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 52h40" stroke="#C9A227" strokeWidth="1.5" strokeLinecap="round" opacity=".7" />
  </svg>
);

export const Logo = ({ light = false, className = "" }) => (
  <Link to="/" className={`group inline-flex items-center gap-3 ${className}`} aria-label={`${site.name} — accueil`} data-testid="logo-link">
    <Monogram className="h-10 w-10 transition-transform duration-500 group-hover:rotate-[-4deg]" />
    <span className="flex flex-col leading-none">
      <span className={`font-heading text-[15px] font-extrabold tracking-[0.18em] ${light ? "text-white" : "text-night"}`}>
        MINES DE PARIS
      </span>
      <span className={`mt-1 text-[10px] font-medium uppercase tracking-[0.24em] ${light ? "text-gold" : "text-slate"}`}>
        Négoce · Sourcing · B2B
      </span>
    </span>
  </Link>
);
